// control.ts — CONTROL_CSS: die EINE token-basierte Input-Hülle (PFS-682/683).
//
// pfs-text-field / pfs-select-field / pfs-textarea-field stylen ihren <input>/
// <select>/<textarea> heute copy-paste-identisch, pfs-search-input ist bereits
// ausgebrochen (hardcoded radius 0.45rem, Border-Fallback #e5e7eb vs #cbd5e1).
// Diese Konstante ist die einzige Quelle: die Control-Elemente inlinen sie und
// ergänzen nur ihr Unikat (Readonly-Box, data-inline, textarea-Umbruch, Such-Icon).
//
// Werte = WC-Mehrheit (text/select/textarea): padding 0.5rem 0.6rem, font-size
// 0.9rem, radius-sm, Focus = outline 2px primary. Border-Fallback auf den
// Registry-Wert #e5e7eb vereinheitlicht (--pfs-color-outline, src/css/tokens.css).
// Checkbox/Radio sind ausgenommen (accent-color, eigene Hülle).
export const CONTROL_CSS = `
input:not([type="checkbox"]):not([type="radio"]),
select,
textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem 0.6rem;
  font: inherit;
  font-size: 0.9rem;
  color: var(--pfs-color-on-surface);
  background: var(--pfs-color-surface);
  border: 1px solid var(--pfs-color-outline);
  border-radius: var(--pfs-radius-sm, 0.375rem);
}
input:not([type="checkbox"]):not([type="radio"]):focus,
select:focus,
textarea:focus {
  outline: 2px solid var(--pfs-color-primary);
  outline-offset: -1px;
  border-color: var(--pfs-color-primary);
}
input:not([type="checkbox"]):not([type="radio"]):disabled,
select:disabled,
textarea:disabled { opacity: 0.75; }
`;
